import type { ItemResponseFormField } from "@memorang/types/src/session/new-session";
import { z } from "zod";

export const createFormSchema = (fields: ItemResponseFormField[]) => {
	const schemaFields: Record<
		string,
		z.ZodUnion<[z.ZodString, z.ZodLiteral<"">]> | z.ZodString
	> = {};

	for (const field of fields) {
		let fieldSchema = z.string();

		switch (field.inputType) {
			case "email":
				fieldSchema = z.string().email("Please enter a valid email address");
				break;
			case "number":
				fieldSchema = z.string().regex(/^\d*$/, "Please enter a valid number");
				break;
			case "currency":
				fieldSchema = z
					.string()
					.regex(/^\d*\.?\d{0,2}$/, "Please enter a valid amount");
				break;
			default:
				fieldSchema = z.string();
		}

		if (field.required) {
			schemaFields[field.id] = fieldSchema.min(1, `${field.label} is required`);
		} else {
			schemaFields[field.id] = fieldSchema.or(z.literal(""));
		}
	}

	return z.object(schemaFields);
};
